import { ApplicationContext } from '../../framework/framework/shared/ApplicationContext';
import classes from '../../framework/framework/tools/classes';
import Emitter from '../../services/eventEmmiter/EventEmmiter';
import { EventTypes } from '../../services/eventEmmiter/EventTypes';
import { BasketService } from '../../services/basket/BasketService';
import { IBasketItem } from '../../services/productService/models/IBasketItem';
import { IBasketModel } from '../../services/productService/models/IBasketModel';
import { SellActionType } from '../../services/productService/models/SellActionType';
import BasketLoginForm from './basketLoginForm/BasketLoginForm';
// import { Helmet } from 'react-helmet';
import OrderDeliveryForm from './orderDeliveryForm/OrderDeliveryForm';
import * as style from './style.css';
import TextInput from '../../components/textInput/TextInput';
import BasketItem from './basketItem/BasketItem';
import ActionButton from '../../components/actionButton/ActionButton';
import React = require('react');

interface IProps {

    appCtx: ApplicationContext;
}
interface IState {
    basket: IBasketModel;
}

export default class DeliveryPage extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            basket: null
        };
    }

    basketService: BasketService;

    componentDidMount() {
        this.basketService = BasketService.Instance();
        this.updateBasket();
        Emitter.on(EventTypes.UserData, () => this.updateBasket());
    }

    updateBasket() {
        this.basketService.calculateBasket((basket: IBasketModel) => this.setState({ basket: basket }));
    }

    render() {
        return (
            <>
                {this.state.basket &&
                    <>
                        <div key={'loginForm'} className={classes(style.delivery)}>
                            {this.state.basket.endUser.isLogged
                                ? <>
                                    <div key={1} >
                                        <h3>Jesteś zalogowany</h3>
                                        <TextInput
                                            key={'name'}
                                            value={this.state.basket.endUser.name}
                                            onChange={null}
                                            onKeyDown={() => { }}
                                            placeholder="name" />
                                        <TextInput
                                            key={'email'}
                                            value={this.state.basket.endUser.email}
                                            onChange={null}
                                            onKeyDown={() => { }}
                                            placeholder="adres email" />
                                    </div>
                                </>
                                : <>
                                    <div key={'login'} >
                                        <h3>Zaloguj się</h3>
                                        <BasketLoginForm
                                            basketService={this.basketService} />

                                        <h4>Załóż nowe konto</h4>

                                        <h3>Co zyskasz</h3>
                                        <ul>
                                            <li>historię swoich zakupów</li>
                                            <li>dostęp do rabatów</li>
                                            <li>możliwość śledzenia paczki</li>
                                            <li>podgląd stanu realizacji</li>
                                        </ul>
                                        <div style={{ width: '280px', margin: 'auto', padding: '10px' }}>

                                            <ActionButton label={'Załóż nowe konto'}
                                                onClick={() => { window.location.href = `${this.props.appCtx.buildUrl('/logowanie')}`; }}
                                                disabled={false} />
                                        </div>
                                    </div>
                                    <div key={'freeForm'} >
                                        <h3>Zakupy bez rejestracji</h3>
                                        <OrderDeliveryForm
                                            // user={this.state.basket.endUser}
                                            basketService={this.basketService} />
                                        {this.state.basket.endUser.hasDeliveryData &&
                                            <div style={{
                                                margin: 'auto',
                                                padding: '10px',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                gap: '3rem'
                                            }}>
                                                <ActionButton label={'Wyślij zamówienie'} onClick={() => this.onBuyActionClick(SellActionType.Order)} >
                                                </ActionButton>
                                                <ActionButton label={'Wyślij zapytanie'} onClick={() => this.onBuyActionClick(SellActionType.RFQ)} >
                                                </ActionButton>
                                            </div>}
                                        {this.props.children}
                                    </div>

                                </>}
                        </div>
                    </>}
            </>
        );
    }

    renderItem(i: IBasketItem): any {
        return <BasketItem
            key={i.slug}
            itemUri={this.props.appCtx.buildUrl('produkty/' + i.slug)}
            item={i}
            onUpdateItem={(e) => this.updateQty(e.quantity, e.productId)}
            onRemoveItem={(e) => this.removeItem(e.productId)}

        />;
    }

    onBuyActionClick(actionType: SellActionType): void {
        this.basketService.processOrder(actionType, () => this.onOrderSend(actionType));
    }

    onOrderSend(actionType: SellActionType): void {
        this.updateBasket();
        const message = actionType === SellActionType.Order ? 'Zamówienie zostało wysłane' : 'Zapytanie zostało wysłane';
        Emitter.emit(EventTypes.Message, message);
    }

    removeItem(productId: number) {
        this.basketService.removeItem(productId, (basket: IBasketModel) => {
            this.setState({ basket: basket });
        });
    }

    updateQty(qty: number, prodId: number) {
        if (qty <= 0) { return; }
        this.basketService.updateItem(prodId, qty, () => {
            this.updateBasket();
        });
    }
}
